import Link from 'next/link'
import { ReactNode } from 'react'

import {
  cn,
  formatCurrency,
  formatDateWithDayOfWeek,
  isEmptyString,
} from '@/shared/lib'
import { ContentBox, Icon } from '@/shared/ui'

import { ContractStatusBadge } from './contract-status-badge'
import { HostPayBadge } from './host-pay-badge'
import { TContractListItem, ZContractStatus } from '../model/schema'

type Props = TContractListItem & {
  displayFee: number
  hostPayTime?: string | null
  href: string
  highlight?: boolean
  action?: ReactNode
}

export const ContractListItem = ({
  contractStatus,
  contractStatusDescription,
  startDate,
  endDate,
  hostPayTime,
  displayFee,
  href,
  highlight = false,
  action,
}: Props) => {
  return (
    <Link className="block" href={href}>
      <ContentBox
        className={cn(
          'px-5 py-4',
          highlight && 'border border-black bg-white px-[19px] py-[15px]',
        )}
        color="light-gray"
      >
        <div className="flex items-center justify-between gap-4">
          <div className="flex flex-col">
            <div className="flex items-center gap-2">
              <ContractStatusBadge
                status={contractStatus}
                highlight={highlight}
              />
              {!isEmptyString(contractStatusDescription) && (
                <span className="typo-label2 font-medium text-purple-500">
                  {contractStatusDescription}
                </span>
              )}
            </div>
            <span className="typo-label1 mt-1.5 text-gray-900">
              {formatDateWithDayOfWeek({
                date: startDate,
                format: 'yyyy.MM.dd',
              })}{' '}
              ~{' '}
              {formatDateWithDayOfWeek({
                date: endDate,
                format: 'yyyy.MM.dd',
              })}
            </span>
            <div className="mt-0.5 flex items-center gap-2">
              <span
                className={cn(
                  'typo-body1 font-semibold',
                  contractStatus === ZContractStatus.Enum.CANCEL &&
                    'line-through',
                )}
              >
                {formatCurrency(displayFee)}원
              </span>
              {!!hostPayTime && <HostPayBadge />}
            </div>
          </div>
          {action || <Icon name="arrow-right" size={24} strokeWidth={1.5} />}
        </div>
      </ContentBox>
    </Link>
  )
}
